<template>
  <div>
    <div class="customer-edit-consultant-address-card-header customer-edit-consultant-form-group--label-dropdown">
      <LabelDropdown
        label="Address Type"
        :select-id="`${idPrefix}-type`"
        :model-value="modelValue?.type || ''"
        flex
        wide
        required
        :disabled="disabled"
        :options="typeOptions"
        @update:modelValue="onFieldChange('type', $event)"
      />
    </div>

    <div class="customer-edit-consultant-address-fields">
      <div class="customer-edit-consultant-address-field-row">
        <div class="customer-edit-consultant-address-field customer-edit-consultant-form-group--label-input">
          <LabelInputField
            :input-id="`${idPrefix}-line1`"
            label="Address Line 1"
            :model-value="modelValue?.address1 || ''"
            placeholder="Street address"
            flex
            :readonly="disabled"
            @update:modelValue="onFieldChange('address1', $event)"
          />
        </div>
        <div class="customer-edit-consultant-address-field customer-edit-consultant-form-group--label-input">
          <LabelInputField
            :input-id="`${idPrefix}-line2`"
            label="Address Line 2"
            :model-value="modelValue?.address2 || ''"
            placeholder="Apartment, suite, etc."
            flex
            :readonly="disabled"
            @update:modelValue="onFieldChange('address2', $event)"
          />
        </div>
      </div>

      <AddressSelector
        :country="modelValue?.country || ''"
        :state="modelValue?.state || ''"
        :city="modelValue?.city || ''"
        :postal-code="modelValue?.postalCode || ''"
        :disabled="disabled"
        @update:country="onFieldChange('country', $event)"
        @update:state="onFieldChange('state', $event)"
        @update:city="onFieldChange('city', $event)"
        @update:postalCode="onFieldChange('postalCode', $event)"
      />
    </div>
  </div>
</template>

<script>
import AddressSelector from '@/components/AddressSelector.vue';
import LabelInputFieldComponent from '@/modules/consultant/components/LabelInputField.vue';
import LabelDropdownComponent from '@/modules/consultant/components/LabelDropdown.vue';

export default {
  name: 'CustomerAddressFields',
  components: {
    AddressSelector,
    LabelInputField: LabelInputFieldComponent,
    LabelDropdown: LabelDropdownComponent,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    idPrefix: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onFieldChange(field, value) {
      this.$emit('update:modelValue', {
        ...(this.modelValue || {}),
        [field]: value,
      });
    },
  },
};
</script>
